export const VALIDATE_RESERVEDTICKET_START = 'VALIDATE_RESERVEDTICKET_START'; 
export const VALIDATE_RESERVEDTICKET_SUCCESS = 'VALIDATE_RESERVEDTICKET_SUCCESS'; 
export const VALIDATE_RESERVEDTICKET_FAILURE = 'VALIDATE_RESERVEDTICKET_FAILURE'; 

export const UPDATE_RESERVEDTICKET_START = 'UPDATE_RESERVEDTICKET_START'; 
export const UPDATE_RESERVEDTICKET_SUCCESS = 'UPDATE_RESERVEDTICKET_SUCCESS'; 
export const UPDATE_RESERVEDTICKET_FAILURE = 'UPDATE_RESERVEDTICKET_FAILURE'; 